import Logger from '@app/utils/logger';

export function calculateSkillScores(data: any[], baselineModel: string, variable: string) {
  // Verify the baselineModel exists in the data
  const baselineModelExists = data.some((r) => r.Model === baselineModel);
  if (!baselineModelExists) {
    Logger.warn(`Reference model ${baselineModel} not found in data`);
    return data;
  }

  return data.map((row) => {
    const processed = { ...row };

    // If this is the baseline model itself, skill score is always 0 (no skill improvement over itself)
    if (row.Model === baselineModel) {
      processed[variable] = 0;
      return processed;
    }

    const baselineRow = data.find(
      (r) =>
        r.Model === baselineModel &&
        r['Prediction timedelta'] === row['Prediction timedelta'] &&
        r.Region === row.Region,
    );

    if (baselineRow && variable) {
      const baselineValue = baselineRow[variable];
      const currentValue = row[variable];

      // Only calculate skill score if both values are valid numbers and baseline is not zero
      if (
        typeof baselineValue === 'number' &&
        !isNaN(baselineValue) &&
        baselineValue !== 0 &&
        typeof currentValue === 'number' &&
        !isNaN(currentValue)
      ) {
        processed[variable] = 100 * (1 - currentValue / baselineValue);
      } else {
        // If we don't have a valid baseline value or current value, don't calculate a skill score
        processed[variable] = null;
      }
    } else {
      // If no baseline data exists for this time point, don't calculate a skill score
      processed[variable] = null;
    }

    return processed;
  });
}
